import { useReveal, revealState } from '../../hooks/useReveal.js';
import styles from './Pillar.module.css';

/**
 * A numbered principle or process step.
 *
 * `drawn` gives it the struck-rule treatment: the top hairline is drawn
 * left to right and the copy rises in behind it. Each drawn pillar observes
 * its own arrival rather than following the section timeline — stacked into
 * one column on a phone, a section-wide stagger would run its whole cascade
 * while every card was still below the fold.
 *
 * `index` feeds the cascade delay for siblings sharing a row.
 */
export function Pillar({ num, title, children, drawn = true, index = 0 }) {
  const [ref, shown] = useReveal({ mode: 'section', disabled: !drawn });

  return (
    <div
      ref={ref}
      className={styles.pillar}
      style={drawn ? { '--i': index } : undefined}
      {...(drawn ? { 'data-drawn': revealState(shown) } : null)}
    >
      <span className={styles.num}>{num}</span>
      <h3 className="h3">{title}</h3>
      <p>{children}</p>
    </div>
  );
}
